<template>
	<router-view></router-view>
</template>

<script>
	import store from 'vx/store'
	import { SET_LOADING } from 'vx/mutation-types'
	import { authorized } from 'vx/getters'
	import { INIT_PUSHER } from 'vx/mutation-types'

	export default {
		store,

		vuex: {
			getters: {
				user: authorized
			}
		},

		data() {
			return {};
		},

		ready() {
			this.$watch('user', function (user, oldUser) {
				if (user && !oldUser) {
					store.dispatch(INIT_PUSHER, user.id);
				}
			})
		},

		events: {
			loading() {
				store.dispatch(SET_LOADING, true);
			},
			loaded() {
				store.dispatch(SET_LOADING, false);
			}
		}
	}
</script>



// WEBPACK FOOTER //
// app.vue?6f432e77